import {
  WebMenuTypeEnum,
  IWebMenu,
  HOME_PAGE_DATA,
  WebmenuPathEnum,
  isTypeWithSlug,
} from '../interfaces/webMenu'

export const mapWebMenus = (arr: IWebMenu[]): { [key: string]: IWebMenu } => {
  let map = {} as { [key: string]: IWebMenu }

  arr.forEach((item: IWebMenu) => {
    const { id, childList = [], url_HU, url_EN } = item
    // TODO remove these to conditions after fixed on BE - GLHF :)
    if (url_HU.endsWith('/') && url_HU !== '/') {
      item.url_HU = url_HU.substring(0, url_HU.lastIndexOf('/'))
    }
    if (url_EN.endsWith('/') && url_EN !== '/') {
      item.url_EN = url_EN.substring(0, url_EN.lastIndexOf('/'))
    }
    map[id] = item
    let childMap = {}
    if (childList.length) {
      childMap = mapWebMenus(childList)
    }
    map = Object.assign(map, childMap)
  })
  return map
}

export const isHomePage = (path: string): boolean => path === '/'

export const prepareMap = (webmenus: IWebMenu[]) => {
  const { id, childList } = HOME_PAGE_DATA
  return [
    {
      ...HOME_PAGE_DATA,
      childList: [
        ...childList,
        ...webmenus.map((webmenu) => {
          webmenu.parent = id
          return webmenu
        }),
      ],
    },
  ]
}

export const getSlug = (path: string): string =>
  path.substring(path.lastIndexOf('/') + 1)

export const getUrlObjectForComponents = (
  type: WebMenuTypeEnum,
  id: string,
  path: string
) => {
  switch (type) {
    case WebMenuTypeEnum.HOME:
      return { pathname: '/' }
    case WebMenuTypeEnum.ACTIVITY:
      return {
        pathname: `/activity`,
        query: { contentId: getSlug(path), webmenuId: id },
      }
    case WebMenuTypeEnum.ACTIVITY_LIST:
      return { pathname: `/activity-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.ARTICLE:
      return {
        pathname: `/article`,
        query: { contentId: getSlug(path), webmenuId: id },
      }
    case WebMenuTypeEnum.ARTICLELIST:
      return { pathname: `/article-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.PHOTOGALLERY:
      return {
        pathname: `/photo-gallery`,
        query: { contentId: getSlug(path), webmenuId: id },
      }
    case WebMenuTypeEnum.PHOTOGALLERYLIST:
      return { pathname: `/photo-gallery-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.VIDEOGALLERY:
      return {
        pathname: `/video-gallery`,
        query: { contentId: getSlug(path), webmenuId: id },
      }
    case WebMenuTypeEnum.VIDEOGALLERYLIST:
      return { pathname: `/video-gallery-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.GENERALLIST:
      return { pathname: `/general-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.FILELIST:
      return { pathname: `/file-list`, query: { webmenuId: id } }
    case WebMenuTypeEnum.MAP:
      return { pathname: `/terkep`, query: { webmenuId: id } }
    case WebMenuTypeEnum.CITYCARD:
      return { pathname: `/citycard`, query: { webmenuId: id } }
    case WebMenuTypeEnum.IMPRESSUM:
      return { pathname: `/imprint`, query: { webmenuId: id } }
    default:
      return { pathname: '/_error' }
  }
}

export const getUrlObjectByParentList = (
  type: WebMenuTypeEnum,
  path: string,
  webmenuId: string,
  isPreview: boolean
) => {
  return {
    pathname: getPathnameByListType(type),
    query: isPreview ? { contentId: getSlug(path), webmenuId: webmenuId, preview: 1 } : { contentId: getSlug(path), webmenuId: webmenuId},
  }
}

export const getPathnameByListType = (type: string) => {
  switch (type) {
    case WebMenuTypeEnum.ACTIVITY_LIST:
      return `/activity`
    case WebMenuTypeEnum.ARTICLELIST:
      return `/article`
    case WebMenuTypeEnum.PHOTOGALLERYLIST:
      return `/photo-gallery`
    case WebMenuTypeEnum.VIDEOGALLERYLIST:
      return `/video-gallery`
    case WebMenuTypeEnum.MAP:
      return `/poi-article`
    case WebMenuTypeEnum.CITYCARD:
      return `/citycard-details`
    default:
      return '/_error'
  }
}

export const equalToOneOfTheUrls = (url: string, webmenu: IWebMenu) => {
  const { url_HU, url_EN } = webmenu
  return url === url_HU || url === url_EN
}

export const partOfOneOfTheUrls = (url: string, webmenu: IWebMenu) => {
  const urlWithoutSlug = url.substring(0, url.lastIndexOf('/'))
  return equalToOneOfTheUrls(urlWithoutSlug, webmenu)
}

export const findMenuItem = (
  webMenus: { [key: string]: IWebMenu },
  path: string
): IWebMenu => {
  const values = Object.values(webMenus)
  let item = values.find((webmenu) => {
    if (equalToOneOfTheUrls(path, webmenu)) {
      return webmenu
    }
  })
  if (!item) {
    const urlWithoutSlug = path.substring(0, path.lastIndexOf('/'))
    item =
      values.find((webmenu) => {
        if (equalToOneOfTheUrls(urlWithoutSlug, webmenu)) {
          return webmenu
        }
      }) || webMenus['HOME'] // TODO change this to dedicated 404
  }

  return item
}

export const urlObjectFactoryForPagesWithSlug = (
  basepath: string,
  item: { heading: string; slug: string },
  webmenu: IWebMenu
) => {
  const { heading, slug } = item
  return {
    urlObject: {
      pathname: basepath,
      query: {
        webmenuId: webmenu.id || heading,
        contentId: slug,
      },
    },
    asPath: webmenu.url_HU + '/' + slug,
  }
}

export const urlObjectFactoryForPages = (
  basepath: string,
  item: { heading: string; slug: string },
  webmenu: IWebMenu,
  type: string
) => {
  const { heading, slug } = item
  const isWithSlug = type === WebMenuTypeEnum.ARTICLELIST || type === WebMenuTypeEnum.ACTIVITY || type === 'ANNOUNCEMENT' || type === 'NEWS'
  return {
    urlObject: {
      pathname: basepath,
      query: {
        webmenuId: webmenu.id || heading,
        contentId: slug,
      },
    },
    asPath: isWithSlug ? webmenu.url_HU + '/' + slug : webmenu.url_HU,
  }
}



export const urlObjectFactoryForWebmenus = (webmenu: IWebMenu) => {
  const { id, url_HU, url_EN, type } = webmenu
  const componentUrl = WebmenuPathEnum[type]
  return {
    urlObject: {
      pathname: componentUrl,
      query: {
        webmenuId: id,
        contentId: id,
      },
    },
    asPath: url_HU,
  }
}
